
export const API_BASE_URL = "https://nsqn8s9ls7.execute-api.us-east-1.amazonaws.com/dev/";
